import {
  CREATE_NEW_PLAN_SUCCESS,
  CREATE_NEW_PLAN_FAILURE,
  CREATE_NEW_PLAN_REQUEST,
  LOAD_PLAN_SUCCESS,
  LOAD_PLAN_FAILURE,
  LOAD_PLAN_REQUEST,
  UPDATE_PLAN_REQUEST,
  UPDATE_PLAN_SUCCESS,
  UPDATE_PLAN_FAILURE,
  DELETE_PLAN_REQUEST,
  DELETE_PLAN_SUCCESS,
  DELETE_PLAN_FAILURE,
  CLEAR_PLAN,
  GET_PLANS_REQUEST,
  GET_PLANS_SUCCESS,
  GET_PLANS_FAILURE,
  EXPORT_PLAN_TO_EXCEL_REQUEST,
  EXPORT_PLAN_TO_EXCEL_SUCCESS,
  EXPORT_PLAN_TO_EXCEL_FAILURE,
  LOAD_PLAN_PATH } from '../constants'

import Api from '../services/api.js'
import history from '../history'

export function createNewPlanRequest(){
  return {
    type: CREATE_NEW_PLAN_REQUEST,
  }
}

export function createNewPlanSuccess(body){
  return {
    type: CREATE_NEW_PLAN_SUCCESS,
    body: body
  }
}

export function createNewPlanFailure(exception){
  return {
    type: CREATE_NEW_PLAN_FAILURE,
    exception: exception
  }
}

export function updatePlanRequest(){
  return {
    type: UPDATE_PLAN_REQUEST,
  }
}

export function updatePlanSuccess(body){
  return {
    type: UPDATE_PLAN_SUCCESS,
    body: body
  }
}

export function updatePlanFailure(exception){
  return {
    type: UPDATE_PLAN_FAILURE,
    exception: exception
  }
}

export function deletePlanRequest(){
  return {
    type: DELETE_PLAN_REQUEST,
  }
}

export function deletePlanSuccess(body, isTemplate){
  return {
    type: DELETE_PLAN_SUCCESS,
    body: body,
    isTemplate: isTemplate
  }
}

export function deletePlanFailure(exception){
  return {
    type: DELETE_PLAN_FAILURE,
    exception: exception
  }
}

export function clearPlan(){
  return {
    type: CLEAR_PLAN
  }
}

export function getPlansRequest(body){
  return {
    type: GET_PLANS_REQUEST
  }
}

export function getPlansSuccess(body, isTemplate){
  return {
    type: GET_PLANS_SUCCESS,
    body: body,
    isTemplate: isTemplate
  }
}

export function getPlansFailure(body){
  return {
    type: GET_PLANS_FAILURE
  }
}

export function loadPlanRequest(){
  return {
    type: LOAD_PLAN_REQUEST,
  }
}

export function loadPlanSuccess(body){
  return {
    type: LOAD_PLAN_SUCCESS,
    body: body
  }
}

export function loadPlanFailure(exception){
  return {
    type: LOAD_PLAN_FAILURE,
    exception: exception
  }
}

export function exportPlanToExcelRequest(){
  return {
    type: EXPORT_PLAN_TO_EXCEL_REQUEST,
  }
}

export function exportPlanToExcelSuccess(body){
  return {
    type: EXPORT_PLAN_TO_EXCEL_SUCCESS,
    body: body
  }
}

export function exportPlanToExcelFailure(exception){
  return {
    type: EXPORT_PLAN_TO_EXCEL_FAILURE,
    exception: exception
  }
}

export function createNewPlan(template_plan_id) {
  let params = {
    template_plan_id: template_plan_id
  }
  return dispatch => {
    dispatch(createNewPlanRequest())
    const api = new Api();
    return api.createNewPlan("/api/v1/plan", params)
    .then(response => {
      Promise.all([
        dispatch(createNewPlanSuccess(response.data))
      ]).then(() => {
        openPlanPage(response.data.id);
      });
    })
    .catch(err => dispatch(createNewPlanFailure(err)));
  }
}

export function updatePlan(plan) {
  let params = {
    plan: plan
  }
  return dispatch => {
    dispatch(updatePlanRequest())
    const api = new Api();
    return api.updatePlan("/api/v1/plan/update", params)
    .then(response => {
      dispatch(updatePlanSuccess(response.data))
    })
    .catch(err => dispatch(updatePlanFailure(err)));
  }
}

export function deletePlan(plan_id, isTemplate) {
  return dispatch => {
    dispatch(deletePlanRequest())
    const api = new Api();
    return api.delete("/api/v1/plan/" + plan_id, null)
    .then(response => {
      dispatch(deletePlanSuccess(response.data, isTemplate))
    })
    .catch(err => dispatch(deletePlanFailure(err)));
  }
}

export function getPlans(isTemplate) {
  let params = {
    params: {
      is_template: isTemplate
    }
  }
  return dispatch => {
    dispatch(getPlansRequest());
    const api = new Api();
    return api.get("/api/v1/plans", params)
    .then(response => {
      dispatch(getPlansSuccess(response.data, isTemplate))
    })
    .catch(err => dispatch(getPlansFailure(err)));
  }
}

export function loadPlan(plan_id, include_hidden_risks, page, search_term, sort_by, column_name, filter_by_tags) {
  let params = {
    params: {
      include_hidden_risks: include_hidden_risks,
      page: page,
      search_term: search_term,
      sort_by: sort_by,
      column_name: column_name,
      filter_by_tags: filter_by_tags
    }
  }
  return dispatch => {
    dispatch(loadPlanRequest())
    const api = new Api();
    return api.get("/api/v1/plan/" + plan_id, params)
    .then(response => {
      dispatch(loadPlanSuccess(response.data))
    })
    .catch(err => dispatch(loadPlanFailure(err)));
  }
}

export function openPlanPage(plan_id){
  history.push(LOAD_PLAN_PATH.replace(':plan_id', plan_id))
}

export function exportPlanToExcel(plan_id, include_hidden_risks, search_term, sort_by, column_name, filterByTags) {
  var params = {
    include_hidden_risks: include_hidden_risks,
    search_term: search_term,
    sort_by: sort_by,
    column_name: column_name,
    filter_by_tags: filterByTags,
  }
  return dispatch => {
    dispatch(exportPlanToExcelRequest())
    const api = new Api();
    return api.get("/api/v1/plan/"+ plan_id + "/export_plan_to_excel", {params: params, responseType: 'blob'})
    .then(response => {
      dispatch(exportPlanToExcelSuccess(response.data))
    })
    .catch(err => dispatch(exportPlanToExcelFailure(err)));
  }
}



// WEBPACK FOOTER //
// ./src/actions/plan.js